export const hideScrollbars = `
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;
